import React from "react";
import { Link } from "react-router-dom";
import { formatEUR, formatNumber, quarterText, targetProgress } from "../lib/reports";
import { Card } from "../ui";
import { TargetBar } from "./Charts";

// Quarterly turnover target (GET /v1/crm/reports/target or a brief's
// quarter_target): won value vs target, with the share of the quarter gone.
export default function TargetCard({ target, title }) {
    if (!target) return null;
    const p = targetProgress(target);
    const timePct = Math.round(p.time);
    return (
        <Card
            title={title || `Quarterly target · ${quarterText(target.quarter)}`}
            actions={<Link to="/settings/reports" className="hz-small hz-no-print">Change target</Link>}
        >
            <div className="hz-row-wrap" style={{ alignItems: "baseline", gap: 10, marginBottom: 10 }}>
                <span className="hz-stat-lg">{formatEUR(target.contracted_eur)}</span>
                {p.hasTarget ? (
                    <span className="hz-muted">
                        of {formatEUR(target.target_eur)} · <strong className="hz-text-body">{formatNumber(target.pct, 1)}%</strong>
                    </span>
                ) : (
                    <span className="hz-muted">won this quarter · no target set</span>
                )}
            </div>
            {p.hasTarget && (
                <>
                    <TargetBar
                        reached={p.reached}
                        time={p.time}
                        label={`${formatNumber(target.pct, 1)}% of the target reached, ${timePct}% of the quarter gone`}
                    />
                    <div className="hz-row-wrap hz-small hz-muted" style={{ marginTop: 8, gap: 16 }}>
                        <span>
                            <span className="hz-legend-swatch fill"></span>Won {formatNumber(target.pct, 1)}%
                        </span>
                        <span>
                            <span className="hz-legend-swatch time"></span>Quarter gone {timePct}% ({target.days_elapsed} of {target.days_total} days)
                        </span>
                        <span className="hz-spacer"></span>
                        <span>{formatEUR(target.remaining_eur)} to go</span>
                    </div>
                </>
            )}
            <div className="hz-small hz-muted" style={{ marginTop: 8 }}>
                {target.wins} {target.wins === 1 ? "win" : "wins"}
                {target.wins_without_value ? ` · ${target.wins_without_value} without a EUR value (not counted)` : ""}
            </div>
        </Card>
    );
}
